import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dirArrow-l",
  "use": "dirArrow-l-usage",
  "viewBox": "0 0 23 6.01",
  "content": "<symbol viewBox=\"0 0 23 6.01\" id=\"dirArrow-l\"><title>dirArrow-l</title><path d=\"M547.5,308.5h-17v2l-6-3,6-3v2h17Z\" transform=\"translate(-524.5 -304.49)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dirArrow-l.svg
// module id = Ptaq
// module chunks = 264